@if (element.validityStatus === "INVALID") {
  <div
    class="invalid-report text-center bold"
    i18n="@@analysis-details-slide-over.thisreportisnolongervalid"
  >
    This report is no longer valid
  </div>
}
@if (isLoading()) {
  <app-loader></app-loader>
}
@if (analysisSafeUrl()) {
  <iframe
    #iframe
    [src]="analysisSafeUrl()"
    [style.opacity]="isLoading() ? '0' : '1'"
    allow="fullscreen"
    frameBorder="0"
    height="99%"
    width="100%"
  ></iframe>
}
